import httpRequest from "./httpRequest";

export default {
    WithdrawMoney(params = {}) {
        return httpRequest.post('/app/index/withdraw', params);
    },
    TransferUSDT(params = {}) {
        return httpRequest.post('/app/index/transfer', params);
    },
    GetReceiveInfo(params = {}) {
        return httpRequest.post('/app/index/receive', params);
    },
    GetTransactionInfo(params = {}) {
        return httpRequest.get('/app/index/transactions', params);
    },
    GetIndexInfo(params = {}) {
        return httpRequest.get('/app/index/index', params);
    },
    GetRegisterInfo(params = {}) {
        return httpRequest.post('/app/index/register', params);
    }
}




// WEBPACK FOOTER //
// ./src/assets/js/request/interface.js